/**
 * Nieve para fondos oscuros (la franja de temporada). Copos blancos sobre el
 * hueso de la portada no se ven, por eso la portada usa banderines de papel
 * picado (Bunting) y la nieve se queda en el pino.
 *
 * Las posiciones salen de una fórmula fija, no de Math.random(): así el
 * pre-render del build y el navegador dibujan exactamente los mismos copos.
 * Cada copo solo anima transform y opacity; con prefers-reduced-motion se
 * quedan quietos repartidos por la franja (ver .snow-flake en index.css).
 */
const FLAKES = Array.from({ length: 18 }, (_, i) => ({
    x: `${(i * 53) % 97 + 1}%`,
    y: `${(i * 37) % 88 + 4}%`,
    size: 3 + ((i * 7) % 4),
    dur: 9 + ((i * 5) % 9),
    delay: -((i * 3.7) % 14),
    drift: (i % 2 ? 1 : -1) * (10 + ((i * 11) % 24)),
}));

export default function SnowDecor() {
    return (
        <div className="snow-field absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
            {FLAKES.map((f, i) => (
                <span
                    key={i}
                    className="snow-flake"
                    style={{
                        '--x': f.x,
                        '--y': f.y,
                        '--s': `${f.size}px`,
                        '--dur': `${f.dur}s`,
                        '--delay': `${f.delay}s`,
                        '--drift': `${f.drift}px`,
                    }}
                />
            ))}
        </div>
    );
}
